import { postRequest } from '@/core';
import { locations } from '@/requests';

export default async function newLocationRequest(locationData) {
	let url = locations.getPath();
	let response = await postRequest(url, {}, locationData);
	return response;
}
